export default "__VITE_ASSET__BJyjpvHM__"